import { render, staticRenderFns } from "./MiscellaneousCategory.vue?vue&type=template&id=1394abd3&"
import script from "./MiscellaneousCategory.vue?vue&type=script&lang=js&"
export * from "./MiscellaneousCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1394abd3')) {
      api.createRecord('1394abd3', component.options)
    } else {
      api.reload('1394abd3', component.options)
    }
    module.hot.accept("./MiscellaneousCategory.vue?vue&type=template&id=1394abd3&", function () {
      api.rerender('1394abd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SettingsDivisionMiscellaneous/Components/MiscellaneousCategory.vue"
export default component.exports